// @ts-nocheck

import { colors } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import React from 'react'
import { ProfilePicture } from '../ProfilePicture'

const SidebarItem = ({ itemData, onClick, isSelected, placeholderPicture }) => {
  const chosenImgStyle = isSelected ? styles.selectedImg : styles.regularImg
  const chosenStyle = isSelected ? styles.selected : styles.regular
  const chosenTextStyle = isSelected ? styles.selectedText : styles.regularText

  const isInitialAssessment =
    itemData.status && itemData.status === 'pre-assessment'
  return (
    <li
      id={itemData.id}
      onClick={onClick}
      style={{ ...styles.item, ...chosenStyle }}
    >
      <ProfilePicture
        type="small"
        url={itemData.picture || placeholderPicture}
        style={{
          ...chosenImgStyle,
          ...styles.image
        }}
      />
      <div style={{ ...chosenTextStyle, ...styles.textContainer }}>
        {`${itemData.name.first} ${itemData.name.last}`}
        {isInitialAssessment && <span style={styles.badge}>INITIAL</span>}
      </div>
    </li>
  )
}

const styles = {
  badge: {
    background: colors.orange,
    color: colors.black,
    display: 'inline-block',
    marginLeft: 12,
    padding: '0px 4px',
    fontSize: 12,
    fontWeight: 'bold',
    borderRadius: 15
  },
  image: {
    float: 'left',
    marginTop: '4px'
  },
  item: {
    listStyleType: 'none',
    height: '50px',
    padding: '3px 0 3px 6px'
  },
  textContainer: {
    cursor: 'pointer',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    padding: '12px 10px 0px 15px',
    minWidth: '0px'
  },
  selected: {
    background: colors.lightgrey,
    fontSize: 14,
    boxSizing: 'border-box',
    borderLeft: '3px solid',
    borderColor: colors.pink,
    paddingLeft: 9
  },
  selectedText: {
    // color: colors.red,
  },
  regular: {
    // background: colors.white,
    paddingLeft: '12px'
  }
}

SidebarItem.propTypes = {
  itemData: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool.isRequired
}

export default SidebarItem
